export default "__VITE_ASSET__daa7ceb0__"